__turbopack_context__.v({
  "animated-gradient-text": "index-module-scss-module__OZXxSG__animated-gradient-text",
  "gradient-overlay": "index-module-scss-module__OZXxSG__gradient-overlay",
  "gradient-text-horizontal": "index-module-scss-module__OZXxSG__gradient-text-horizontal",
  "gradient-text-vertical": "index-module-scss-module__OZXxSG__gradient-text-vertical",
  "pause-on-hover": "index-module-scss-module__OZXxSG__pause-on-hover",
  "text-content": "index-module-scss-module__OZXxSG__text-content",
  "vertical": "index-module-scss-module__OZXxSG__vertical",
  "with-border": "index-module-scss-module__OZXxSG__with-border",
});
